import React, { useState } from "react";
import { useEffect } from "react";
import "./Checkout.css";
import Usernav from "./Usernav";
import Adminnav from "./Adminnav";
import Sellernav from "./Sellernav";
import emailjs from 'emailjs-com';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toastify from "../Util/toastify";
import BaseURL from "../Util/BaseURL";
const Checkout = () => {
  const [coupon, setCoupon] = useState();
  const [temp, setTemp] = useState([]);
  const [i, setI] = useState(0);
  const [address, setAddress] = useState("");
  const [landmark, setLandmark] = useState("");
  const [phnumber, setPhnumber] = useState("");
  const [pincode, setPincode] = useState("");
  const [payment, setPayments] = useState("");
  const [netAmount, setNetTotal] = useState();
  const [totalAmount, setTotal] = useState(0);
  const [products, setProducts] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [date, setDate] = useState(new Date().toUTCString());
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [orderNo, setOrder] = useState(0);
  const [hub, setHub] = useState("");
  const [hubs, setHubs] = useState([]);
  const getCartDetails = async () => {
    const r = await axios.get(
      `${BaseURL}getCart?name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setProducts(r.data);
  };
  var nav = useNavigate();
  var totalDiscount = totalAmount - netAmount;

  function paymentGateway() {
    var options = {
      key: "rzp_test_5eMt9t8O214gAD",
      key_secret: "G7Fb19D7rCWj0BPPOnI8vOsG",
      amount: netAmount * 100,
      currency: "INR",
      name: "Paying to VCart",
      handler: function (response) {
        if (response.razorpay_payment_id) {
          toastify("Payment Success", "success");
          order(response.razorpay_payment_id);
        }
      },
    };
    var pay = new window.Razorpay(options);
    pay.open();
  }

  function next() {
    if (
      address != "" &&
      landmark != "" &&
      district != "" &&
      state != "" &&
      phnumber != "" &&
      pincode != ""
    ) {
      if(hub==="")
        toastify("Select the nearest Distribution Hub","error")
      else
      if (phnumber.length > 10 || phnumber.length < 10)
        toastify("Phone Number should be 10 Numbers", "error");
      else if (pincode.length > 6 || pincode.length < 6)
        toastify("Pincode should be 6 digits", "error");
      else {
        document.getElementById("payments").style.display = "block";
        document.getElementById("shipping").style.display = "none";
        if (trigger === false) {
          getCartDetails();
          setTrigger(true);
        }
      }
    } else {
          toastify("Fields cannot be empty", "error");
    }
  }

  function back() {
    document.getElementById("payments").style.display = "none";
    document.getElementById("shipping").style.display = "block";
  }
  var sum = 0;
  async function set() {
    
    const dh = await axios.get(`${BaseURL}GetHub`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    setHubs(dh.data);
    products.map(
      (data) => (sum = sum + totalAmount + data.price * data.quantity)
    );
    setTotal(sum);
    sum = 0;
  }
  useEffect(() => {
    set();
  }, [products]);
  useEffect(() => {
    setNetTotal(totalAmount);
  }, [totalAmount]);

  async function addCoupon() {
    const r = await axios.get(`${BaseURL}GetCoupon?coupon=${coupon}`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    if (r.data) {
      if (temp.includes(r.data.couponCode)) {
        toastify("Coupon Already Added", "success");
        setCoupon("");
      } else {
        setNetTotal(netAmount - r.data.discount);
        setTemp((temp) => [...temp, r.data.couponCode]);
        toastify("Coupon Added Successfully", "success");
        setCoupon("");
      }
    } else {
      toastify("Invalid Coupon", "error");
      setCoupon("");
    }
  }

  async function order(props) {
    const user = await axios.get(
      `${BaseURL}FindByName?name=${sessionStorage.getItem("user")}`
    );
    var username = sessionStorage.getItem("user");
    var isBilled = false;
    payment === "COD" ? (isBilled = false) : (isBilled = true);
    const s = await axios.post(
      `${BaseURL}OrderSummary`,
      {
        date,
        isBilled,
        isCancelled: false,
        netAmount,
        totalAmount,
        totalDiscount,
        username,
        address,
        landmark,
        phnumber,
        pincode,
        payment,
        state,
        district,
        hub,
      },
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    let ad = address +", "+ district+", " + state+"-"+pincode
    var templatePrams = {
			from_name: "V-Cart",
			to_name: user.data[0].name,
			address: ad,
      id: s.data,
      date : date,
      total : netAmount,
			reply_to: user.data[0].email
		}
		emailjs.send("E-Commerce","template_oy2ju7h",templatePrams,"CjBEsekJa-7gCzQeU")
    axios.post(
      `${BaseURL}AddOnlinePayment`,
      { ordernumber: s.data, refid: props },
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    products.map((data) => (
      <>
        {axios.post(
          `${BaseURL}AddOrderItems`,
          {
            ordernumber: s.data,
            price: data.price,
            product_id: data.product_id,
            quantity: data.quantity,
            sellerId: data.sellerId,
            acceptance: false,
            status: "Not Dispatched",
          },
          {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("pic"),
            },
          }
        )}
        {axios.post(
          `${BaseURL}updateProductQuantity?product_id=${data.product_id}&quantity=${data.quantity}&sign=0`,
          {},
          {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("pic"),
            },
          }
        )}
      </>
    ));

    axios.delete(
      `${BaseURL}deleteItems?name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    payment === "COD" ? (
      toastify("Order Placed Successfully", "success")
    ) : (
      <></>
    );
    nav("/OrderSummary", { state: { orderNo: s.data } });
  }
  async function navigateSummary() {
    if(payment === "")
      toastify("Choose Payment Method","error")
    else{
      if (payment === "Pay Online") {
        paymentGateway();
      } else await order();
    }
  }
  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      <div id="shipping">
        <section id="hero">
          <div className="hero-container">
            <div className="hero-logo">
              <h1 className="font-weight-bold">Shipping</h1>
            </div>
          </div>
        </section>
        <div className="form-container">
          <form action="" className="checkout-form">
            <div className="input-line">
              <label htmlFor="name">Address</label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Your Complete Address"
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="name">Landmark</label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Nearby Landmark"
                onChange={(e) => setLandmark(e.target.value)}
              />
            </div>
            <div className="input-container">
              <div className="input-line">
                <label htmlFor="name">District</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter the District"
                  onChange={(e) => setDistrict(e.target.value)}
                />
              </div>
              <div className="input-line">
                <label htmlFor="name">State</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter the State"
                  onChange={(e) => setState(e.target.value)}
                />
              </div>
            </div>
            <div className="input-container">
              <div className="input-line">
                <label htmlFor="name">Phone Number</label>
                <input
                  type="number"
                  name="name"
                  id="name"
                  placeholder="10 Digit Mobile Number"
                  onChange={(e) => setPhnumber(e.target.value)}
                />
              </div>
              <div className="input-line">
                <label htmlFor="name">Pincode</label>
                <input
                  type="number"
                  name="name"
                  id="name"
                  placeholder="6 Digit Pin Code"
                  onChange={(e) => setPincode(e.target.value)}
                />
              </div>
            </div>
            <label className="my-0">Nearby Distribution Hub</label>
            <select
              className="my-4 input-line"
              style={{ height: "30px" }}
              onChange={(e) => {
                setHub(e.target.value);
              }}
            >
                <option disabled selected hidden>Select Your Nearest Distribution Hub</option>
              {hubs.map((hub, key) => (
                <option value={key}>{hub.name}</option>
              ))}
            </select>
          </form>
        </div>
        <input
          type="button"
          onClick={() => next()}
          className="forwardBtn my-3 d-none d-xl-block d-lg-block d-md-block"
          value="Next"
        />
        <input
          type="button"
          onClick={() => next()}
          className="mx-auto my-3 d-block d-xl-none d-lg-none d-md-none"
          value="Next"
        />
      </div>
      <div id="payments">
        <section id="hero">
          <div className="hero-container">
            <div className="hero-logo">
              <h1 className="font-weight-bold">Payment</h1>
            </div>
          </div>
        </section>
        <div className="mx-auto col-lg-4 offset-lg-4 my-4 d-none d-xl-block d-lg-block d-md-block">
          <div className="coupons checkout my-">
            <ul>
              <li className="coupon">Add Coupons</li>
              <li className="cart-total">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter the Coupon Code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
              </li>
            </ul>
            <button className="proceed-btn" onClick={() => addCoupon()}>
              Add
            </button>
          </div>
          <div className="checkout my-3">
            <ul>
              <li className="subtotal">
                subtotal
                <span>{totalAmount}</span>
              </li>
              <li className="cart-total">
                Total
                <span>{netAmount}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mx-3 col-lg-4 offset-lg-4 my-4 d-block d-xl-none d-lg-none d-md-none">
          <div className="coupons checkout my-">
            <ul>
              <li className="coupon">Add Coupons</li>
              <li className="cart-total">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter the Coupon Code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                />
              </li>
            </ul>
            <button className="proceed-btn" onClick={() => addCoupon()}>
              Add
            </button>
          </div>
          <div className="checkout my-3">
            <ul>
              <li className="subtotal">
                subtotal
                <span>{totalAmount}</span>
              </li>
              <li className="cart-total">
                Total
                <span>{netAmount}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center">
          <select
            className="my-4"
            style={{ width: "100px", height: "30px" }}
            onChange={(e) => {
              setPayments(e.target.value);
            }}
          >
            <option disabled selected hidden>Select Payment Option</option>
            <option value="COD">COD</option>
            <option value="Pay Online">Pay Online</option>
          </select>
          <br />
          <input
            onClick={() => {
              navigateSummary();
            }}
            type="button"
            value="Place Order"
            className="my-3"
          />
          <br />
          <input
            onClick={() => {
              back();
            }}
            type="button"
            value="Back"
            className="mb-3"
          />
        </div>
      </div>
    </>
  );
};

export default Checkout;
